/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import Box from '@atlaskit/ds-explorations/box';
import Inline from '@atlaskit/ds-explorations/inline';
import Heading from '@atlaskit/heading';
import ArrowleftIcon from '@atlaskit/icon/glyph/chevron-left-large';
import ArrowrightIcon from '@atlaskit/icon/glyph/chevron-right-large';
import { N70 } from '@atlaskit/theme/colors';
var Header = /*#__PURE__*/memo(function Header(_ref) {
  var monthLongTitle = _ref.monthLongTitle,
    year = _ref.year,
    _ref$previousMonthLab = _ref.previousMonthLabel,
    previousMonthLabel = _ref$previousMonthLab === void 0 ? 'Last month' : _ref$previousMonthLab,
    _ref$nextMonthLabel = _ref.nextMonthLabel,
    nextMonthLabel = _ref$nextMonthLabel === void 0 ? 'Next month' : _ref$nextMonthLabel,
    handleClickPrev = _ref.handleClickPrev,
    handleClickNext = _ref.handleClickNext,
    testId = _ref.testId;
  return jsx(Box, {
    display: "block",
    paddingInline: "space.100",
    "aria-hidden": "true"
  }, jsx(Inline, {
    gap: "space.0",
    alignItems: "center",
    justifyContent: "space-between"
  }, jsx(Button, {
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickPrev,
    testId: testId && "".concat(testId, "--previous-month"),
    iconBefore: jsx(ArrowleftIcon, {
      label: previousMonthLabel,
      size: "medium",
      primaryColor: "var(--ds-text-subtlest, ".concat(N70, ")"),
      testId: testId && "".concat(testId, "--previous-month-icon")
    })
  }), jsx(Heading, {
    level: "h400",
    as: "div",
    testId: testId && "".concat(testId, "--current-month-year")
  }, "".concat(monthLongTitle, " ").concat(year)), jsx(Button, {
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickNext,
    testId: testId && "".concat(testId, "--next-month"),
    iconBefore: jsx(ArrowrightIcon, {
      label: nextMonthLabel,
      size: "medium",
      primaryColor: "var(--ds-text-subtlest, ".concat(N70, ")"),
      testId: testId && "".concat(testId, "--next-month-icon")
    })
  })));
});
Header.displayName = 'Header';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Header;